import { getSenderInfo } from "@/api/bm";

const bmStore = {
    namespaced: true,
    state: {
        sender: {},
        xExvtNo: null,
        xBuyers: [],
        xForwardFiles: [],
        xSubject: "",
        xContent: "",
        xMktSndNo: null,
        xIsReply: "N",
    },
    getters: {
        pushParams(state) {
            return {
                xExvtNo: state.xExvtNo,
                xBuyers: state.xBuyers,
                xForwardFiles: state.xForwardFiles,
                xSubject: state.xSubject,
                xContent: state.xContent,
                xMktSndNo: state.xMktSndNo,
                xIsReply: state.xIsReply,
            };
        },
        sender(state) {
            return state.sender;
        },
    },
    mutations: {
        SET_PUSH_PARAMS(state, params) {
            state.xExvtNo = params.exvtNo ?? null;
            state.xBuyers = params.buyers ?? [];
            state.xSubject = params.subject ?? "";
            state.xContent = params.content ?? "";
            state.xIsReply = params.isReply ?? "N";
            state.xMktSndNo = params.mktSndNo ?? null;
            state.xForwardFiles = params.forwardFiles ?? [];
        },
        CLEAR_PUSH_PARAMS(state) {
            state.xExvtNo = null;
            state.xBuyers = [];
            state.xForwardFiles = [];
            state.xSubject = "";
            state.xContent = "";
            state.xMktSndNo = null;
            state.xIsReply = "N";
        },
        SET_SENDER(state, sender) {
            state.sender = sender;
        },
    },
    actions: {
        async GET_SENDER({ commit }) {
            const { data } = await getSenderInfo();
            commit("SET_SENDER", data.data);
        },
    },
};

export default bmStore;
